import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import languageManager from '../../../../services/languageManager'

import { Form, Input, InputNumber, Select, Switch, Divider } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'

const BankForm = (props) => {
    const [layout, setLayout] = useState(props.layout)
    // const [customerId, setCustomerId] = useState(props.customerId)
    const [values, setValues] = useState(props.values)

    const [form] = Form.useForm()
    const { Option } = Select

    useEffect(() => {
        console.log(props)
        // setCustomerId(props.customerId)
        setValues(props.values)
        if (_.isEmpty(props.values)) {
            form.resetFields()
        } else {
            form.setFieldsValue(props.values)
        }
    }, [props.values])

    const submitForm = (values) => {
        // values.customer_id = customerId
        console.log(values)
        props.submitForm(values)
    }

    return (
        <Form
            form={form}
            {...layout}
            id="BankForm"
            onFinish={submitForm}
        >
            <Form.Item
                label="Nome"
                name="name"
                rules={[{ required: true, message: 'Inserisci un nome identificativo per la banca di appoggio' }]}
            >
                <Input />
            </Form.Item>
            <Divider />
            <Form.Item
                label="IBAN"
                name="iban"
                rules={[{ required: true, message: 'Inserisci un IBAN valido per la banca' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Descrizione"
                name="description"
            >
                <Input />
            </Form.Item>
            <Form.Item name="id" noStyle><Input type="hidden" /></Form.Item>
        </Form>
    )
}

const mapStateToProps = state => {
    return {
        commonState: state.commonState,
    }
}

export default connect(mapStateToProps)(BankForm)